import { useState, useEffect, useContext, Dispatch } from 'react';
import moment from 'moment';
import { useOwnProfile } from '../Context/ProfileContext';
import { DocumentDto } from '../DocumentT';
import { InvoiceStatusDTO, LexOfficeS } from '../LexOfficeS';
import { DocumentS } from '../../Templates/Documents/DocumentS';
import { ViolationContext } from '../Context/ViolationContext';

// eslint-disable-next-line import/prefer-default-export, @typescript-eslint/no-unused-vars
export const useDocumentBookkeepingStatus = (invoice: DocumentDto, setDraft: Dispatch<boolean>) => {
  const { profile } = useOwnProfile();
  const { interceptViolation } = useContext(ViolationContext);
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [status, setStatus] = useState<InvoiceStatusDTO | null>(null);
  const { id: invoiceId, lastModified, documentType } = invoice;
  const { syncedAt } = status ?? { syncedAt: null };
  const { accountingTool } = profile ?? {};
  const isUptodate = syncedAt !== null && moment(syncedAt) > moment(lastModified);
  const toolMissing = accountingTool === null;

  useEffect(() => {
    if (accountingTool && DocumentS.isInvoice(documentType)) {
      setLoading(true);
      LexOfficeS.getInvoiceStatus(invoiceId)
        .then(setStatus)
        .finally(() => setLoading(false));
    }
  }, [invoiceId, accountingTool, documentType]);

  const sync = async () => {
    setSyncing(true);
    const ok = await LexOfficeS.publishInvoiceV2(invoiceId, interceptViolation);
    setSyncing(false);
    if (ok) {
      setStatus({ syncedAt: new Date() });
      setDraft(false);
    }
  };

  return { loading, syncedAt, isUptodate, toolMissing, sync, syncing };
};
